import { render, staticRenderFns } from "./NepaleseADCountryWiseReport.vue?vue&type=template&id=33997bbb&"
import script from "./NepaleseADCountryWiseReport.vue?vue&type=script&lang=js&"
export * from "./NepaleseADCountryWiseReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports